module.exports = __webpack_public_path__ + "static/img/login.8e492b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login.jpg
// module id = 1634
// module chunks = 31